// extracted by mini-css-extract-plugin
module.exports = {"toolContentWrapper":"ToolsContent_toolContentWrapper__2fIVo"};